module.exports = {
  TRIDENT: 1,
  PRESTO: 2,
  CHROMIUM: 4,
  GECKO: 8,
  WEBKIT: 16,
  V8: 32,
};
